import { memo, useEffect, type PropsWithChildren } from 'react'
import { useSetDebugInteractivity } from './use-interactive'
import { useInteractiveBoundsSync } from './use-bounds-sync'
import { useInteractiveHitTest } from './use-hit-test'
import { isInteractiveRenderer } from './window-props'

const Provider = memo(({ children }: PropsWithChildren) => {
  const setDebugInteractivity = useSetDebugInteractivity()

  // Single shared loop that measures every registered interactive element
  // (and pushes bounds to main itself, off the React commit path), plus a
  // single cursor hit-test against those bounds that drives interactivity.
  useInteractiveBoundsSync()
  useInteractiveHitTest()

  useEffect(() => {
    if (typeof window?.ipc === 'undefined') {
      return
    }
    const unsub = window.ipc.onDebugInteractivityChange((debug: boolean) => {
      setDebugInteractivity(debug)
    })
    return () => {
      unsub()
    }
  }, [setDebugInteractivity])

  return children
})
Provider.displayName = 'InteractiveProvider'

const Placeholder = memo(({ children }: PropsWithChildren) => {
  return children
})
Placeholder.displayName = 'InteractiveProviderPlaceholder'

export const InteractiveProvider = isInteractiveRenderer ? Provider : Placeholder
